export const schools = [
  {
    'name': 'Northwestern University',
    'start': '2013',
    'end': '2017',
    'special': null,
    'gpa': 3.626,
    'location': 'Evanston, IL',
    'major': 'Computer Science',
    'minor': 'Economics',
    'other': 'Financial Economics Certificate - Kellogg School of Management'
  },
  {
    'name': 'The University of Edinburgh',
    'start': '9/2015',
    'end': '12/2015',
    'special': 'Study Abroad',
    'gpa': null,
    'location': 'Edinburgh, Scotland'
  },
  {
    'name': 'The Dawson School',
    'start': '2009',
    'end': '2013',
    'special': null,
    'gpa': 3.98,
    'location': 'Lafayette, CO'
  }
]

export const awards = [
  {
    'name': 'Dean\'s List',
    'description': 'Placed on Northwestern University\'s Dean\'s list 3 times: Spring 2014, Fall 2014, and Spring 2015'
  },
  {
    'name': 'Excellence in Design',
    'description': 'My four-person group’s design was recognized for excellence in design at Northwestern University’s Design Expo.'
  }
]
